<style lang="scss" scoped>
  @import '../../../sass/variables';

  .colorpicker {
    width: 13px;
    height: 13px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0) !important;
    vertical-align: middle;
    float: left;
    display: inline;
    padding: 0;
    margin: 4px 8px 0 0;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid $gray-soft-2;

    &::-webkit-color-swatch {
      border: none;
    }

    &::-webkit-color-swatch-wrapper {
      padding: 0;
    }
  }
</style>

<template>
  <input
    class="colorpicker"
    type="color"
    :value="value"
    @change="update"
  >
</template>

<script>
// import '../../../vendors/jscolor.js';
// jscolor.lookupClass = null;

export default {
  props: {
    value: {
      default: '#FFFFFF',
    },
  },

  mounted () {
    // this.$nextTick(() => {
    //   let picker = new jscolor(this.$refs.picker);
    //   picker.fromString(this.value);
    //   picker.onFineChange = () => {
    //     this.update(picker.toHEXString());
    //   }
    // });
  },

  methods: {
    update (ev) {
      this.$emit('input', ev.target.value);
    },
  },
};
</script>
